import React from "react";
import SocialMediaIcons from "../headerComponents/socialMediaIcons";
import "./footerContactInformations.scss";
const FooterContactInformations = () => {
  return (
    <div className="footer-contact-info-container">
      <p className="footer-copyright-container">
        Copyrights 2024. All rights are reserved by Cube Global Services Ltd
      </p>
      {/* <div className="footer-social-media-container">
        <SocialMediaIcons size={24} gap={33} color={"white"} />
      </div> */}
    </div>
  );
};

export default FooterContactInformations;
